import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref, nextTick } from 'vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MaintenanceBanner',
  emits: ['maintenance-banner-height'],
  setup(__props, { emit }) {

  

  const { warning } = useIcons()

  const maintenanceBannerElement = ref(null as HTMLDivElement | null)

  const maintenanceBannerTitle = computed(() => process.env.VUE_APP_MAINTENANCE_BANNER_TITLE)

  const maintenanceBannerDescription = computed(() => process.env.VUE_APP_MAINTENANCE_BANNER_DESCRIPTION)

  onMounted(() => {
    nextTick(() => {
      if (maintenanceBannerElement.value) {
        emit('maintenance-banner-height', maintenanceBannerElement.value.getBoundingClientRect().height)
      }
    })
  })

  onBeforeUnmount(() => {
    emit('maintenance-banner-height', 0)
  })

return { __sfc: true,emit, warning, maintenanceBannerElement, maintenanceBannerTitle, maintenanceBannerDescription, computed, onBeforeUnmount, onMounted, ref, nextTick, useIcons, SVGRenderer }
}

})